import { axiosInstance } from ".."

const admins = async (querry="") =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/user/admins?showDownline=0${querry}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default admins;